import { X } from "lucide-react";

export function BadgeItem({ label, src, onRmove = () => {} }) {
  return (
    <div className="rounded-full border border-gray-200 bg-gray-50 inline-flex items-center space-x-1 py-1 px-2">
      <div className="w-4 h-4 rounded-full border border-gray-100 overflow-hidden">
        <img src={src} className="object-cover" />
      </div>
      <div className="text-xs">{label}</div>
      <button>
        <X className="w-3 h-3" />
      </button>
    </div>
  );
}
